export default "__VITE_ASSET__CbefCzoV__"